import { Navigate, useLocation } from "react-router-dom";
import { useUserContext } from "../../contexts/UserContext";

const NonZeroLedgerBalanceRedirect: React.FC = () => {
  const { isNyUser, isUserLoading } = useUserContext();
  const location = useLocation();

  const queryString = location.search;

  if (isUserLoading) {
    return <div>Loading...</div>;
  }

  if (isNyUser) {
    return <Navigate to={`/non-zero-ledger-balances-ny${queryString}`} replace />;
  } else {
    return <Navigate to={`/non-zero-ledger-balances${queryString}`} replace />;
  }
};

export default NonZeroLedgerBalanceRedirect;
